/** Paths of the application; organization pages live under ``/o/:organizationId``. */
export const paths = {
  login: '/login',
  home: '/',
  organizations: '/organizations',
  profile: '/profile',
  adminUsers: '/admin/users',
  adminOrganizations: '/admin/organizations',
  organization: (id: number) => `/o/${id}`,
  employees: (id: number) => `/o/${id}/employees`,
  positions: (id: number) => `/o/${id}/employees/positions`,
  objects: (id: number) => `/o/${id}/objects`,
  documents: (id: number) => `/o/${id}/documents`,
  telematics: (id: number) => `/o/${id}/telematics`,
  object: (id: number, objectId: string) => `/o/${id}/objects/${objectId}`,
  equipment: (id: number) => `/o/${id}/equipment`,
  rentals: (id: number) => `/o/${id}/rentals`,
  rental: (id: number, rentalId: string) => `/o/${id}/rentals/${rentalId}`,
  warehouses: (id: number) => `/o/${id}/warehouse`,
  catalog: (id: number) => `/o/${id}/warehouse/catalog`,
  stock: (id: number) => `/o/${id}/warehouse/stock`,
} as const;
